import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=430975fa&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('430975fa')) {
      api.createRecord('430975fa', component.options)
    } else {
      api.reload('430975fa', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=430975fa&", function () {
      api.rerender('430975fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8GnsH8KUlmczR/JS/pricehelp.vue"
export default component.exports